import { Divider } from '@looker/components';
import { globalTheme } from '@pulsepointinc/bi-components';
import styled from 'styled-components';

export const StyledDivider = styled(Divider)`
  margin-top: 16px;
  margin-bottom: 24px;
  background: ${globalTheme.colors.outlineLight};
`;
